/**
 * Boards of area (d) — communication. OWNED BY area (d) — communication (keep `id`, `href`, `path` stable: the dev navigator,
 * the smoke test and the layout audit read them). Generated by the foundation on 2026-10-15.
 */
import { lazy } from "react";
import type { BoardDef } from "@/boards/types";

export const communicationBoards: BoardDef[] = [
  {
    id: "Admin-Discussions",
    ref: "145",
    title: "Cabinet compta — Discussions",
    area: "communication",
    path: "/compta/discussions",
    href: "/compta/discussions",
    permission: ["discussions", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.discussions",
    note: "Fils entreprise ↔ cabinet ; ?entrepriseId= filtre un client. ThreadsScreen réutilisable (scope) pour AG-Discussions.",
    space: "compta",
    component: lazy(() => import("./boards/Admin-Discussions")),
  },
  {
    id: "Admin-Messagerie",
    ref: "145b",
    title: "Messagerie unifiée — création, compta, site",
    area: "communication",
    path: "/messagerie",
    href: "/messagerie",
    permission: ["discussions", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.messagerie",
    space: "compta",
    note: "Messagerie unifiée (création, compta, site).",
    component: lazy(() => import("./boards/Admin-Messagerie")),
  },
  {
    id: "Admin-RendezVous",
    ref: "147",
    title: "Cabinet compta — Rendez-vous",
    area: "communication",
    path: "/rendez-vous",
    href: "/rendez-vous",
    permission: ["bookings", "read"],
    persona: "admin",
    kind: "page",
    nav: "rdv",
    space: null,
    component: lazy(() => import("./boards/Admin-RendezVous")),
  },
  {
    id: "Admin-Disponibilites",
    ref: "147b",
    title: "Cabinet compta — Disponibilités",
    area: "communication",
    path: "/parametres/disponibilites",
    href: "/parametres/disponibilites",
    permission: ["bookings", "read"],
    persona: "admin",
    kind: "page",
    nav: "parametres",
    space: null,
    note: "Onglet des Paramètres, aussi ouvert depuis Rendez-vous.",
    component: lazy(() => import("./boards/Admin-Disponibilites")),
  },
  {
    id: "Admin-Parametres-Profil",
    ref: "147c",
    title: "Cabinet — Paramètres · Profil et sécurité",
    area: "communication",
    path: "/parametres",
    href: "/parametres",
    permission: ["settings.personal", "read"],
    persona: "admin",
    kind: "page",
    nav: "parametres",
    space: null,
    component: lazy(() => import("./boards/Admin-Parametres-Profil")),
  },
  {
    id: "Admin-Parametres-Modeles",
    ref: "147e",
    title: "Cabinet — Paramètres · Messages et motifs d'invalidation",
    area: "communication",
    path: "/parametres/modeles",
    href: "/parametres/modeles",
    permission: ["settings.firm", "read"],
    persona: "admin",
    kind: "page",
    nav: "parametres",
    note: "Modèles de messages + messages par motif + catalogue des e-mails automatiques (lecture seule).",
    space: null,
    component: lazy(() => import("./boards/Admin-Parametres-Modeles")),
  },
  {
    id: "Admin-Parametres-Forfait",
    ref: "147f",
    title: "Cabinet — Paramètres · Forfait comptable",
    area: "communication",
    path: "/parametres/forfait",
    href: "/parametres/forfait",
    permission: ["settings.firm", "read"],
    persona: "admin",
    kind: "page",
    nav: "parametres",
    note: "Grilles officielles des contrats (20 paliers de 20, 79 → 799 € sociétés, 9 → 199 € AE) à la place de l'ancienne grille du board.",
    space: null,
    component: lazy(() => import("./boards/Admin-Parametres-Forfait")),
  },
  {
    id: "Admin-Parametres-Integrations",
    ref: "147g",
    title: "Cabinet — Paramètres · Intégrations",
    area: "communication",
    path: "/parametres/integrations",
    href: "/parametres/integrations",
    permission: ["settings.firm", "read"],
    persona: "admin",
    kind: "page",
    nav: "parametres",
    note: "Fournisseurs réels de l'API (Bridge, Stancer, BoldSign, Iopole, INSEE, INPI, Google Meet) avec mode sandbox / production.",
    space: null,
    component: lazy(() => import("./boards/Admin-Parametres-Integrations")),
  },
  {
    id: "Admin-Parametres-Notifications",
    ref: "147h",
    title: "Cabinet — Paramètres · Notifications",
    area: "communication",
    path: "/parametres/notifications",
    href: "/parametres/notifications",
    permission: ["settings.personal", "read"],
    persona: "admin",
    kind: "page",
    nav: "parametres",
    space: null,
    component: lazy(() => import("./boards/Admin-Parametres-Notifications")),
  },
];
